import Client from '@/classes/Api/Client';

const state = {
  comments: [],
};

const getters = {};

const mutations = {
  setComments(state, data) {
    state.comments = data;
  },
  appendComment(state, comment) {
    state.comments.push(comment);
  },
};

const actions = {
  loadComments({commit}, sourceId) {
    return Client.getSourceComments(sourceId).then((response) => {
      commit('setComments', response.data);
    });
  },

  createComment({dispatch}, data) {
    switch (data.type) {
      case 'dictionary_req':
        return dispatch('createDictionaryReqComment', data);
      case 'lmsp_req':
        return dispatch('createLMSPReqComment', data);
    }
  },

  createDictionaryReqComment({commit}, data) {
    return Client.createOperatorDictionaryReqComment(
      data.sourceId,
      data.text
    ).then((response) => {
      commit('appendComment', response.data);
    });
  },

  createLMSPReqComment({commit}, data) {
    return Client.createHeadLMSPReqComment(data.sourceId, data.text).then(
      (response) => {
        commit('appendComment', response.data);
      }
    );
  },

  clear({commit}) {
    commit('setComments', []);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
